"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
/**
 * hides upload status component
 * clear the uploadStatus state from redux store
 */
function hideUploadStatus() {
  return (0, _utils.actionCreator)(_types.SET_UPLOAD_STATUS_VISIBILITY, false);
}
var _default = exports["default"] = hideUploadStatus;